<script>
import http from '../api/http.js'
import store from '../store/index';
import common from "@/units/common.js";
import router from '../router'

import jwt_decode from "jwt-decode";
import { Button, Form, FormItem, Input, Message } from 'element-ui'

function browse(SOURCEID, BUSINESSTYPE, callback) {
  if (!SOURCEID) {
    return;
  }
  http.api.Browse({
    SOURCEID: SOURCEID,
    BUSINESSTYPE: BUSINESSTYPE,
    TERMINALTYPE: 2, //1(手机端)，2(电脑端)
    ORGID: common.orgId()
  }).then((res) => {
    if (callback) {
      callback(res);
    }
  });
}
function getProductUrl(id, type) {
  if (type == "2") {
    return "/SoundBookDetail/" + id;
  }
  if (type == "3") {
    return "/detail/qkDetail/" + id;
  }
  if (type == "4") {
    return "/AlbumDetail/" + id;
  }
  return "/ElectronBookDetail/" + id;
}
function openProductUrl(id, type) {
  //window.open(this.getProductUrl(id, type), '_blank');
  router.push(this.getProductUrl(id, type));
}
function openError(msg) {
  router.push({ name: 'error', params: { message: msg } });
}
function setCacheNav(val) {
  localStorage.setItem("HDSWebNav", JSON.stringify(val));
}
function getCacheNav() {
  return localStorage.getItem("HDSWebNav") ? JSON.parse(localStorage.getItem("HDSWebNav")) : [];
}

export default {
  browse,
  getProductUrl,
  openProductUrl,
  openError,
  getCacheNav,
  setCacheNav,
};
</script>



// WEBPACK FOOTER //
// src/common/GlobalMethod.vue